import React from "react";
import { Server, ArrowRight } from "lucide-react";
import { AppConfig } from "../../utils/Constants";

const ApiRedirectPage: React.FC = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-background-default dark:bg-background-dark text-text-primary dark:text-text-primaryDark font-sans px-4 relative overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-0 right-0 w-96 h-96 bg-secondary/5 dark:bg-secondary/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-80 h-80 bg-primary/5 dark:bg-primary-dark/10 rounded-full blur-3xl"></div>
      </div>

      {/* Logo */}
      <div className="absolute top-8 left-8 z-10">
        <img src={AppConfig.LOGO_URL} alt={`${AppConfig.PRODUCT_NAME_SHORT} Logo`} className="w-10 h-10" />
      </div>

      {/* Main Content */}
      <div className="relative z-10 text-center space-y-8 max-w-2xl mx-auto">
        {/* Icon Card */}
        <div className="flex justify-center">
          <div className="relative inline-block">
            <div className="absolute inset-0 bg-secondary/20 dark:bg-secondary/30 rounded-2xl blur-xl"></div>
            <div className="relative bg-background-paper dark:bg-background-paperDark rounded-2xl p-6 border border-divider dark:border-divider-dark shadow-lg">
              <Server
                className="w-20 h-20 text-secondary"
                aria-label="Server Icon"
              />
            </div>
          </div>
        </div>

        {/* Badge */}
        <div className="inline-flex items-center justify-center px-4 py-2 rounded-full bg-background-paper dark:bg-background-paperDark border border-divider dark:border-divider-dark shadow-sm">
          <span className="text-sm font-medium text-text-secondary dark:text-text-secondaryDark">
            API Endpoint
          </span>
        </div>

        {/* Heading */}
        <div className="space-y-4">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-primary dark:text-primary-dark tracking-tight">
            This is the API
          </h1>
          <p className="text-lg md:text-xl text-text-secondary dark:text-text-secondaryDark max-w-xl mx-auto leading-relaxed">
            It seems you've stumbled onto the backend API. This is not where the magic happens! Let's get you back to the right place.
          </p>
        </div>

        {/* CTA Button */}
        <div className="flex justify-center pt-4">
          <a
            href={AppConfig.PRODUCT_URL}
            className="group inline-flex items-center gap-2 px-8 py-4 bg-secondary text-white rounded-xl font-semibold shadow-lg hover:bg-secondary-hover transition-all duration-200 hover:shadow-xl hover:scale-105 active:scale-100"
          >
            Go to {AppConfig.PRODUCT_NAME_SHORT}
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </a>
        </div>

        {/* Footer */}
        <footer className="pt-12 text-sm text-text-secondary dark:text-text-secondaryDark">
          <p>
            &copy; {new Date().getFullYear()} {AppConfig.PRODUCT_NAME} - All rights reserved.
          </p>
        </footer>
      </div>
    </div>
  );
};

export default ApiRedirectPage;
